// extracted by mini-css-extract-plugin
export default {"dateLocation":"dateAndLocation_dateLocation__revCr"};